// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".loading-mask[data-v-52b1b83a]{align-items:center;display:flex;height:100%;justify-content:center;left:0;pointer-events:none;position:absolute;top:0;width:100%;z-index:9999}.sp-icon[data-v-52b1b83a]{fill:currentColor;background-size:contain}.sp-icon.is-spinner[data-v-52b1b83a]{animation:figureEightSpinnerDash-52b1b83a 1s linear infinite}@keyframes figureEightSpinnerDash-52b1b83a{0%{stroke-dashoffset:0}to{stroke-dashoffset:320}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
